export const ELASTICITY_CHARTS2_REQUEST = "ELASTICITY_CHARTS2_REQUEST";
export const ELASTICITY_CHARTS2_SUCCESS = "ELASTICITY_CHARTS2_SUCCESS";
export const ELASTICITY_CHARTS2_FAILURE = "ELASTICITY_CHARTS2_FAILURE";
